// model, just a wp term object basically
var FilterTerm = Backbone.Model.extend({
    defaults: {
        name: null,
        value: null,
        selected: false
    }
}); 
export {FilterTerm};